var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 19,
    r: 18.2016,
    fill: "white",
    stroke: "#DADADA",
    strokeWidth: 0.596774
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0891 24.445L14.1678 26.8073C13.9946 26.9175 13.8135 26.9647 13.6245 26.949C13.4355 26.9332 13.2702 26.8703 13.1284 26.76C12.9867 26.6498 12.8765 26.5118 12.7977 26.3462C12.719 26.1805 12.7032 25.9956 12.7505 25.7915L13.7898 21.3269L10.3174 18.3268C10.1599 18.1851 10.0616 18.0235 10.0226 17.8421C9.9835 17.6607 9.99516 17.4837 10.0575 17.3111C10.1205 17.1379 10.215 16.9961 10.341 16.8859C10.467 16.7756 10.6402 16.7048 10.8607 16.6733L15.4434 16.2717L17.2151 12.0669C17.2938 11.878 17.416 11.7362 17.5817 11.6417C17.7474 11.5472 17.9165 11.5 18.0891 11.5C18.2623 11.5 18.4315 11.5472 18.5965 11.6417C18.7616 11.7362 18.8838 11.878 18.9631 12.0669L20.7348 16.2717L25.3175 16.6733C25.538 16.7048 25.7112 16.7756 25.8372 16.8859C25.9632 16.9961 26.0577 17.1379 26.1207 17.3111C26.1837 17.4843 26.1957 17.6616 26.1566 17.8431C26.1175 18.0245 26.019 18.1857 25.8608 18.3268L22.3884 21.3269L23.4277 25.7915C23.475 25.9962 23.4592 26.1814 23.3805 26.3471C23.3018 26.5128 23.1915 26.6504 23.0498 26.76C22.9081 26.8703 22.7427 26.9332 22.5537 26.949C22.3647 26.9647 22.1836 26.9175 22.0104 26.8073L18.0891 24.445Z",
    fill: "#FFD12D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRate);
export default __webpack_public_path__ + "static/media/rate.adffa465bc45b1ce4b416a319904bf35.svg";
export { ForwardRef as ReactComponent };